<template>
  <div class="layout_header">
    <header-title></header-title>
    <header-avatar></header-avatar>
  </div>
</template>

<script>
import headerTitle from './header-title'
import headerAvatar from './header-avatar'
export default {
  components: {
    headerTitle,
    headerAvatar
  }
}
</script>

<style lang="scss" scoped>
.layout_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: $layout-header-height;
  background-color: $color-primary;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/header/index.vue